import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'
import * as decorations from './decorations'
import { active } from 'd3-transition'

/*
 * Returns reusuable tween functions that have access to the incoming arguments.
 * This makes it easier to reuse the functions with the d3 `.tween` call's bound `this`
 */
export default function (yScale, xScale, serieScale, serie, strokeWidth, labelsConfig) {
  return {
    all: function (d) {
      let container = d3.select(this)
        , rect = container.select('rect')
        , interpolateX = interpolate(rect.attr('x'), xScale.groupScale(d.rangeId) + serieScale(serie._columnIdx))
        , interpolateY = interpolate(rect.attr('y'), yScale(Math.max(0, d._range[1])))
        , interpolateHeight = interpolate(rect.attr('height'), Math.abs(yScale(d._range[0]) - yScale(d._range[1])))
        , interpolateWidth = interpolate(rect.attr('width'), serieScale.bandwidth())

      return t => {
        let x = interpolateX(t)
          , y = interpolateY(t)
          , width = interpolateWidth(t)
          , height = interpolateHeight(t)

         rect.attr('x', x)
         rect.attr('width', width)
         rect.attr('y', y)
         rect.attr('height', height)

         container.call(decorations.position, strokeWidth, {x, width, y, height}, labelsConfig)
      }
    },
    decorations: function () {
      active(this).call(decorations.default, strokeWidth)
    },
    horizontal: function (d) {
      // Start transitioning all of the rects horizontally
      let container = d3.select(this)
        , rect = container.select('rect')
        , w0 = rect.attr('width')
        , w1 = serieScale.bandwidth()
        , x0 = rect.attr('x')
        , x1 = xScale.groupScale(d.rangeId) + serieScale(serie._columnIdx)
        , interpolateX = interpolate(x0, x1)
        , interpolateWidth = interpolate(w0, w1)
        , height = +rect.attr('height')

      if (!height) {
        // If this bar doesn't have height, we don't need to change its dimensions, it was probably just removed
        return
      }

      return t => {
        let width = interpolateWidth(t)
          , x = interpolateX(t)

        rect.attr('width', width)
        rect.attr('x', x)

        container.call(decorations.position, strokeWidth, {x, width}, labelsConfig)
      }
    },

    vertical: function (d) {
      let container = d3.select(this)
        , rect = container.select('rect')
        , y0 = rect.attr('y')
        , y1 = yScale(Math.max(0, d._range[1]))
        , h0 = Number(rect.attr('height'))
        , h1 = Math.abs(yScale(d._range[0]) - yScale(d._range[1]))
        , interpolateHeight = interpolate(h0, h1)
        , interpolateY = interpolate(y0, y1)

      return t => {
        let height = interpolateHeight(t)
          , y = interpolateY(t)

        rect.attr('y', y)
        rect.attr('height', height)
        container.call(decorations.position, strokeWidth, {y, height}, labelsConfig)
      }
    }
  }
}
